import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2, XCircle } from 'lucide-react';
export function AudienceSection() {
  const isFor = ['Sientes que la gente no es del todo honesta contigo y quieres la verdad.', 'Estás en el mundo de las ventas o los negocios y necesitas cerrar más tratos.', 'Quieres mejorar tu vida social y saber exactamente qué piensa tu entorno.', 'Buscas una ventaja competitiva "invisible" en cualquier interacción humana.'];
  const notFor = ['Buscas trucos de magia o manipulación oscura sin ética.', 'No tienes intención de observar a las personas con respeto y atención.', 'Prefieres seguir viviendo en la ignorancia de lo que los demás piensan de ti.'];
  return <section className="py-24 bg-background relative overflow-hidden" data-id="element-11">
      <div className="container mx-auto px-4 max-w-6xl relative z-10" data-id="element-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12" data-id="element-13">
          {/* Is For */}
          <FadeIn direction="right" data-id="element-14">
            <div className="bg-surface rounded-3xl p-8 sm:p-10 border border-green-900/30 h-full relative overflow-hidden" data-id="element-15">
              <div className="absolute top-0 right-0 w-64 h-64 bg-green-500/5 rounded-full blur-[80px]" data-id="element-16"></div>

              <h3 className="text-3xl font-bold text-white mb-8 flex items-center gap-4" data-id="element-17">
                <span className="bg-green-500/20 text-green-400 p-2 rounded-lg" data-id="element-18">
                  <CheckCircle2 className="w-8 h-8" data-id="element-19" />
                </span>
                Esto es para ti si:
              </h3>

              <div className="space-y-6" data-id="element-20">
                {isFor.map((item, index) => <div key={index} className="flex items-start gap-4" data-id="element-21">
                    <CheckCircle2 className="w-6 h-6 text-green-500 shrink-0 mt-1" data-id="element-22" />
                    <p className="text-lg text-slate-300 leading-relaxed" data-id="element-23">
                      {item}
                    </p>
                  </div>)}
              </div>
            </div>
          </FadeIn>

          {/* Not For */}
          <FadeIn direction="left" delay={0.2} data-id="element-24">
            <div className="bg-surface rounded-3xl p-8 sm:p-10 border border-red-900/30 h-full relative overflow-hidden opacity-90" data-id="element-25">
              <div className="absolute top-0 right-0 w-64 h-64 bg-red-500/5 rounded-full blur-[80px]" data-id="element-26"></div>

              <h3 className="text-3xl font-bold text-white mb-8 flex items-center gap-4" data-id="element-27">
                <span className="bg-red-500/20 text-red-400 p-2 rounded-lg" data-id="element-28">
                  <XCircle className="w-8 h-8" data-id="element-29" />
                </span>
                Esto NO es para ti si:
              </h3>

              <div className="space-y-6" data-id="element-30">
                {notFor.map((item, index) => <div key={index} className="flex items-start gap-4" data-id="element-31">
                    <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-1 opacity-80" data-id="element-32" />
                    <p className="text-lg text-slate-400 leading-relaxed" data-id="element-33">
                      {item}
                    </p>
                  </div>)}
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}